import { createLucideIcon } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

// This icon landed after the Lucide version currently pinned by Electron.
// Define the upstream paths locally so the UI can use the requested glyph
// without importing a named export that this bundle does not provide.
export const MessageCircleCheck = createLucideIcon('MessageCircleCheck', [
  [
    'path',
    {
      d: 'M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719',
      key: 'bubble',
    },
  ],
  ['path', { d: 'm16 9-5.5 5.5L8 12', key: 'check' }],
])

/**
 * A settled answer, rendered the same everywhere a resolved ask-user card
 * shows one — the chat thread and the output view: a compact bordered row
 * with the chat-bubble check, the answer, and the optional "why" under it.
 */
export function ResolvedAnswer({
  answers,
  explanation,
  emptyLabel = 'No answer',
  className,
  iconClassName,
}: {
  answers: Array<string>
  explanation?: string
  /** What an empty answer reads as — "Skipped" for the optional feedback card. */
  emptyLabel?: string
  className?: string
  iconClassName?: string
}) {
  const filled = answers.length > 0
  return (
    <div className={twMerge('relative rounded-2xl p-2.5 shadow-sm', className)}>
      <div className="flex min-w-0 items-start gap-1.5">
        <MessageCircleCheck
          aria-label={filled ? 'Answered' : undefined}
          aria-hidden={filled ? undefined : true}
          className={twMerge(
            'mt-px size-3.5 shrink-0',
            filled ? 'text-success-subtle' : 'text-foreground-disabled',
            iconClassName,
          )}
        />
        <span
          className={twMerge(
            'min-w-0 cursor-text select-text text-xs',
            filled ? 'text-foreground' : 'text-foreground-placeholder',
          )}
        >
          {filled ? answers.join(', ') : emptyLabel}
        </span>
      </div>
      {explanation && (
        <p className="text-foreground-secondary mt-1 cursor-text select-text pl-5 text-[11px] leading-normal">
          {explanation}
        </p>
      )}
    </div>
  )
}
